import { Button } from '@myua/kit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as googleBulkActions from '../actions';
import { GoogleDrive } from '../../icons/GoogleDrive';
import { createHash, GoogleBulkMode, GoogleBulkParams } from '../model';
import { getLinks, getInProgress, getProgressValues } from '../selectors';
import { getSettings } from '../../app/selectors';
import '../styles.scss';

export const GoogleBulkButton: React.FC<GoogleBulkParams & { showLabel?: boolean }> = (props) => {
  const dispatch = useDispatch();
  const hash = createHash(props);
  const link = useSelector(getLinks)[hash];
  const inProgress = useSelector(getInProgress)[hash];
  const progressValue = useSelector(getProgressValues)[hash];
  const disabled = props.mode === GoogleBulkMode.assets && props.assetIds.length === 0;
  const settings = useSelector(getSettings);

  if (!settings?.can_download_bulk_google) {
    return null;
  }

  let label;
  if (progressValue) {
    label = `${progressValue}%`;
  } else if (props.showLabel) {
    label = 'Create link';
  }

  return link ? (
    <Button className="al-google-bulk-button" href={link} target="_blank" icon={<GoogleDrive />}>
      Open
    </Button>
  ) : (
    <Button
      className="al-google-bulk-button"
      disabled={disabled}
      loading={inProgress}
      onClick={() => dispatch(googleBulkActions.linkRequested(props))}
      icon={<GoogleDrive style={{ opacity: disabled ? 0.4 : undefined }} />}
    >
      {label}
    </Button>
  );
};
